module.exports = __webpack_public_path__ + "static/media/warning-circle.89c1ea85.svg";